import {getRoundsJsonSuccess} from "modules/actions/rounds";
import Api from "modules/utils/Api";
import {call, put} from "typed-redux-saga/macro";

export const fetchRoundsSaga = function* () {
	const rounds = yield* call(Api.Jsons.rounds);
	if (rounds?.data.rounds?.length) {
		yield* put(getRoundsJsonSuccess(rounds.data.rounds));
	}
};

export default fetchRoundsSaga;
